// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"f4-z","colorTextValue":"g4-z","swatches":"h4-z","collapseLink":"i4-z","isCollapsed":"j4-z","dropdown":"k4-z","disabled":"l4-z"};